// Hooks
import useModel from "./useModel";

// Models
import SponsorAdmin from "models/SponsorAdmin/SponsorAdmin";

export default function useSponsorAdmin(sponsorAdminId) {
  return useModel(SponsorAdmin, "getSingleConfig", [sponsorAdminId]);
}
